import React, { Component } from 'react';

import { CardActions, Divider, IconButton, Tooltip } from 'material-ui';
import Fav from './Fav';
import ExpandMoreIcon from 'material-ui-icons/ExpandMore';

import Collapse from 'material-ui/transitions/Collapse';

import GoogleMap from './GoogleMap';

const style = {
	actionSpace: {
		flex: '1 1 auto'
	},
	expandIcon: {
		transition: 'transform 0.3s ease'
	},
	expandIconExpanded: {
		transition: 'transform 0.3s ease',
		transform: 'rotate(-180deg)'
	}
};

export default class JobCardMapExpander extends Component {
	constructor() {
		super();

		this.state = {
			mapExpanded: false
		};
	}

	render() {
		return (
			<React.Fragment>
				<CardActions className="cardActions">
					{!!this.props.uid &&
						!!this.props.oid &&
						!!this.props.job &&
						!!this.props.fav && (
							<Fav
								uid={this.props.uid}
								oid={this.props.oid}
								job={this.props.job}
							/>
						)}
					<div style={style.actionSpace} />
					<Tooltip
						id="expandMoreIcon"
						title={this.state.mapExpanded ? 'Hide Map' : 'View Map'}
						placement="bottom"
					>
						<IconButton
							className="cardActionsBtn"
							onClick={() => {
								this.setState({ mapExpanded: !this.state.mapExpanded });
							}}
							aria-expanded={this.state.mapExpanded}
							aria-label="Show more"
							style={
								this.state.mapExpanded
									? style.expandIconExpanded
									: style.expandIcon
							}
						>
							<ExpandMoreIcon />
						</IconButton>
					</Tooltip>
				</CardActions>
				<Divider light />
				<Collapse in={this.state.mapExpanded}>
					<GoogleMap location={this.props.location} />
				</Collapse>
			</React.Fragment>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/JobCardMapExpander.js